import s from './Campaign1.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from 'react-helmet-async';

const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'キャンペーン', link: '/campaign' },
  { label: '【2025限定！】ケアンズツアー学生割引プラン' }
];

const campaign1 = () => {
  return (
    <>
              <Helmet>
        <title>【2025限定！】ケアンズツアー学生割引プラン</title>
        <meta property="og:title" content="【2025限定！】ケアンズツアー学生割引プラン" />
        <meta property="og:image" content="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E5%AD%A6%E7%94%9F%E9%99%90%E5%AE%9A%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3%E5%AE%9F%E6%96%BD%E4%B8%AD.png" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/campaign/【2025限定！】ケアンズツアー学生割引`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
    <div className={s.root}>
      <SubHeader
        title="【2025限定！】ケアンズツアー学生割引プラン"
        breadcrumbs={breadcrumbs}
      />
      <div className={s.flex}>
        <div className={s.width}>
          <div className={s.cardContent}>
            <h2 className={s.cardTitle}>
              【2025限定！】ケアンズツアー学生割引プラン
            </h2>
            <ul className={s.article}>
              <li>
                <i className="fa fa-calendar"></i>
                <a href="https://dev.mightyaussie.com/blog/magazine/num01">
                  <time itemProp="datePublished" className="entry-date published" dateTime="2019-12-13T10:42:20+09:00">
                    2025年1月7日
                  </time>
                </a>
              </li>
              <li>
                <i className="fa fa-user"></i>
                <span itemProp="author" itemScope itemType="https://schema.org/Person" className="vcard author">
                  <span className="fn" itemProp="name">ジェイさんツアー</span>
                </span>
              </li>
              <li>
                <i className="fa fa-pencil"></i>
                <span itemProp="articleSection">
                  キャンペーン
                  <a href="https://dev.mightyaussie.com/category/blog/magazine"></a>
                </span>
              </li>
            </ul>
          </div>
          <img
              src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E5%AD%A6%E7%94%9F%E9%99%90%E5%AE%9A%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3%E5%AE%9F%E6%96%BD%E4%B8%AD.png"
              alt="キュランダ観光ツアー ジェイさんツアーマガジン#01"
              className={s.cardImage}
            />

            <div className={s.message}>
              <div className={s.boxIcon}>
                <i className="fas fa-info-circle"></i>
              </div>
              <div className={s.boxText}>
                <p>
                  <span className={s.about}>★ <strong>キャンペーン概要</strong> ★</span>
                </p>
                <p className={s.sub}>
                  <strong>① <span>ベーシックプラン</span></strong>
                </p>
                <p>
                  どれでも好きなツアー2件申し込みで <span style={{ color: "#ff0000" }}>$20</span> 割引
                </p>
                <p className={s.sub}>
                  <strong>② <span>複数割引プラン</span></strong>
                </p>
                <p>
                  対象のツアー申し込みで、<span style={{ color: "#ff0000" }}>最大$70</span> の割引！
                </p>
              </div>
            </div>
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2025/01/%E5%89%B2%E5%BC%95%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0-2.png" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2025/01/%E5%89%B2%E5%BC%95%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0-2-3-1024x480.png" alt="" />

          <div className={s.test}>
            <h3 className={s.primary}>対象ツアーはこちら</h3>
          </div>
          <div className={s.images}>
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2025/01/1-576x1024.png" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2025/01/2-1-576x1024.png" alt="" />
          </div>
          <div className={s.campaign}>
          <h3>キャンペーンに関する注意事項</h3>
          <ul>
            <li>16歳以上の学生限定です。</li>
            <li>有効な学生証を持つ、学生の方のみ対象です。（参加者全員が学生である必要があります）</li>
            <li>予約時備考欄に”ベーシックプラン/複数割引プラン/または学生キャンペーン希望”とご記入ください。</li>
            <li>ツアー開始の48時間前のご予約が必要です。</li>
            <li><strong class="under">同一カートでの決済が対象です。個別で決済された場合は対象外</strong>となりますので、LINEかメールでご連絡ください。</li>
            <li>他の割引との併用はできません。</li>
            <li>王道パッケージはすでに割引が適用されて料金です。</li>
          </ul>
          </div>
          <div style={{ textAlign: 'center' }}>
  <a href="/tours/620627">
    <img
      className={s.vcImg}
      src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E5%AE%9A%E7%95%AA%E3%81%8A%E3%81%99%E3%81%99%E3%82%81-%E3%83%91%E3%83%83%E3%82%B1%E3%83%BC%E3%82%B8.jpg"
      alt="おすすめパッケージ"
    />
  </a>
</div>
          <div className={s.test}>
            <h3 className={s.primary}>予約方法</h3>
          </div>
          <div className={s.images1}>
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0.jpg" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0.png" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0-1.jpg" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0-2.jpg" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0-3.jpg" alt="" />
            <img src="https://dev.mightyaussie.com/wp-content/uploads/2024/01/%E2%91%A0-4.jpg" alt="" />
          </div>
          <div className={s.button}><a class="vc_general vc_btn3 vc_btn3-size-lg vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-danger" href="/faqs" title="">よくある質問をチェック</a></div>
        </div>
        {/*<Aside />*/}
      </div>
    </div>
    </>
  );
};

export default campaign1;
